module.exports = __webpack_public_path__ + "img/KKE-24.4e26156c.png";